import { RootSelector, getStore } from '../../reducers';
import { FavoriteShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { Asset } from '../../api';
import { Loading } from '../finder/model';

export const getFavorite: RootSelector<FavoriteShape> = createSelector(
  getStore,
  (state) => state.favorite,
);

export const getData: RootSelector<FavoriteShape['data']> = createSelector(
  [getFavorite],
  (favorite) => favorite.data,
);

export const getAssetsInFavorite: RootSelector<Partial<Record<Asset['id'], boolean>>> =
  createSelector(getData, (data) => {
    const result: Partial<Record<Asset['id'], boolean>> = {};
    data.asset_ids.forEach((id) => {
      result[id] = true;
    });
    return result;
  });

export const getAssetsById: RootSelector<Partial<Record<Asset['id'], Asset>>> = createSelector(
  getData,
  (data) => {
    const result: Partial<Record<Asset['id'], Asset>> = {};
    data.assets.forEach((asset) => {
      result[asset.id] = asset;
    });
    return result;
  },
);

export const getLoading: RootSelector<Loading> = createSelector(
  getFavorite,
  (favorite) => favorite.loading,
);

export const getHasNextPage: RootSelector<boolean> = createSelector(
  getFavorite,
  (favorite) => favorite.hasNextPage,
);

export const getScrollHash: RootSelector<string> = createSelector(
  getFavorite,
  (favorite) => favorite.scrollHash,
);

export const getInProgress: RootSelector<Partial<Record<Asset['id'], true>>> = createSelector(
  getFavorite,
  (favorite) => favorite.inProgress,
);

export const getAllInProgress: RootSelector<FavoriteShape['allInProgress']> = createSelector(
  getFavorite,
  (favorite) => favorite.allInProgress,
);
